<template>
  <div class="about-me">
    <div class="about-me-top">
      <div class="me-top-word">
        <h2>公司简介</h2>
        <p>武汉市天鸿在线科技有限责任公司成立于2000年，主要从事智能化系统工程咨询、设计和实施,系统集成,</p>
        <p>软件产品研发与销售,软件定制开发和运维保障服务等业务。</p>
				<p>经过20余年的不断发展进步,公司已成为湖北省内在多个高科技领域都具有顶尖实力和影响力的IT与工程服务商,</p>
        <p>为客户提供从技术咨询、规划设计、系统实施、技术培训到运营服务全链条一体化服务。</p>
      </div>
<!--      <div>
        <Arrow/>
      </div> -->
    </div>
    <div class="about-me-center">
      <Tabs :animated="false">
        <TabPane label="发展历程">
          <div class="development" >
            <Row>
              <Col span="4"></Col>
              <Col span="16">
                <div class="deve-content" v-for="item of deveData" :key="item.goodsId">
                  <div class="deve-left" >
                    <div v-if="item.goodsId%2!=0">
                      <div class="deve-left-content">
                        <h4>{{item.title}}</h4>
                      </div>
                      <p>{{item.content}}</p>
                    </div>
                  </div>
                  <div class="deve-center">
                    <div class="deve-center-top">
                      <span>{{item.year}}</span>
                    </div>
                    <div class="deve-center-line">
                    </div>
                    <div class="deve-center-outer-circle">
                      <div class="inner-circle">
                      </div>
                    </div>
                    <div class="deve-center-line" v-if="item.goodsId!=5">
                    </div>
                  </div>
                  <div class="deve-right" >
                    <div v-if="item.goodsId%2==0">
                      <div class="deve-right-content" >
                        <h4>{{item.title}}</h4>
                      </div>
                      <p>{{item.content}}</p>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span="4"></Col>
            </Row>

                      <!--  <Timeline>
                              <TimelineItem>
                                  <p class="time">2021年</p>
                                  <p class="content">以软件产品为核心,整合资源孵化生态,提高天鸿业务生态竞争力和价值</p>
                              </TimelineItem>
                              <TimelineItem>
                                  <p class="time">2018年</p>
                                  <p class="content">各业务告诉发展,逐步融合业务,提升竞争力,形成由专到全的生态发展格局</p>
                              </TimelineItem>
                              <TimelineItem>
                                  <p class="time">2014年</p>
                                  <p class="content">重点发展智能化及大型系统集成项目,延申业务维度,领航市场新业态</p>
                                  <p class="content">重点业务领域，明确未来产品核心，研发软件产品</p>
                              </TimelineItem>
                              <TimelineItem>
                                  <p class="time">2008年</p>
                                  <p class="content">稳中求变,由产品销售商转变为系统集成服务商,为用户提供专业全面的服务</p>
                              </TimelineItem>
                              <TimelineItem>
                                  <p class="time">2005</p>
                                  <p class="content">以PC、服务器、网络设备等产品销售业务为主体,奠定天鸿在线基础</p>
                              </TimelineItem>
                              <TimelineItem>
                                  <p class="time">2000</p>
                                  <p class="content">公司成立于2000年,标志着天鸿在线成立正式启航</p>
                              </TimelineItem>
                          </Timeline> -->
          </div>
        </TabPane>

        <TabPane label="公司架构">
          <div class="companyStructure">
              <Row>
                <Col span="2"></Col>
                <Col span="20">
                  <div class="company-img">
                    <img src="../../assets/img/company-structure.png" width="100%">
                  </div>
                  </Col>
                <Col span="2"></Col>
              </Row>
          </div>
        </TabPane>
          <TabPane label="荣誉资质">
            <Row>
              <Col span="2"></Col>
              <Col span="20">
                <div class="honor">
					<big-img v-if="showImg" @clickit="viewImg" :imgSrc="imgSrc"></big-img>
					<div class="Three-honor" v-for="item of threeHonor" :key="item.goodsId">
						<div class="Three-honor1">
							<div class="Three-honor2">
								<div class="Three-honor3">
									<img :src="item.img1" width="100%" height="100%" />
								</div>
							</div>
						<p>{{item.word1}}</p>
						</div>
						<div class="Three-honor-interval">
							
						</div>
						<div class="Three-honor1">
							<div class="Three-honor2">
								<div class="Three-honor3">
									<img :src="item.img2" width="100%" height="100%" />
								</div>
								
							</div>
							<p>{{item.word2}}</p>
						</div>
						<div class="Three-honor-interval">
							
						</div>
						<div class="Three-honor1" :style="item.word3==''?'opacity: 0;':''">
							<div class="Three-honor2">
								<div class="Three-honor3" >
									<img :src="item.img3" width="100%" height="100%" />
								</div>
								
							</div>
							<p>{{item.word3}}</p>
						</div>
					</div>
							
					<div class="Four-honor" v-for="item of fourHonor" :key="item.goodsId">
						<div class="Four-honor1">
							<div class="Four-honor2">
								<div class="Four-honor3">
									<img :src="item.img1" width="100%" height="100%" />
								</div>
							</div>
						<p>{{item.word1}}</p>
						</div>
						<div class="Four-honor-interval">
							
						</div>
						<div class="Four-honor1">
							<div class="Four-honor2">
								<div class="Four-honor3">
									<img :src="item.img2" width="100%" height="100%" />
								</div>
								
							</div>
						<p>{{item.word2}}</p>
						</div>
						<div class="Four-honor-interval">
							
						</div>
						<div class="Four-honor1">
							<div class="Four-honor2">
								<div class="Four-honor3">
									<img :src="item.img3" width="100%" height="100%"/>
								</div>
								
							</div>
						<p>{{item.word3}}</p>	
						</div>
						<div class="Four-honor-interval">
							
						</div>
						<div class="Four-honor1">
							<div class="Four-honor2">
								<div class="Four-honor3">
									<img :src="item.img4" width="100%" height="100%"/>
								</div>
								
							</div>
						<p>{{item.word4}}</p>	
						</div>
						<div class="Four-honor-interval">
							
						</div>
						<div class="Four-honor1" :style="item.word5==''?'opacity: 0;':''">
							<div class="Four-honor2">
								<div class="Four-honor3">
									<img :src="item.img5" width="100%" height="100%"/>
								</div>
							</div>
						<p>{{item.word5}}</p>	
						</div>
					</div>		
                </div>

                </Col>
              <Col span="2"></Col>
            </Row>

          </TabPane>

          <TabPane label="招贤纳士">
            <div class="recruitment">
              <Row>
                <Col span="2"></Col>
                <Col span="20">
                  <div class="recruitment-word">
                    <h3>走进天鸿</h3>
                    <p>天鸿在线坚持“诚信铸就品质，创新引领未来”的企业文化，发展20余年，厂商合作渠道日益完善,在湖北省17个地市州均设有专职销售人员,各个产品线签约核心渠道200余家。在服务器存储、网络、安全、国产化电脑等领域均具有行业认证资深工程师,为各方渠道的项目合作提供强大技术支撑,公司总人数约百余人。</p>
                    <p>产品数字化和数字产业化的万亿商机,必将引领天鸿在线乘着新一轮科技革命、产业变革滚滚向前的时代巨轮,一路风驰电掣,从"信息化社会"向着"智能化社会"的美好未来进发!</p>
                  </div>

                  <div class="recruitment-img">
                    <div class="top-img">
                     <div class="recruitment-img1">
                        <img src="../../assets/img/me-img1.png" width="100%">
                      </div>
                      <div class="jg"></div>
                      <div class="recruitment-img1">
                        <img src="../../assets/img/me-img2.png" width="100%">
                      </div>
                      <div class="jg"></div>
                      <div class="recruitment-img1">
                        <img src="../../assets/img/me-img3.png" width="100%">
                      </div>
                      <div class="jg"></div>
                      <div class="recruitment-img1">
                        <img src="../../assets/img/me-img4.png" width="100%">
                      </div>
                    </div>
                    <div class="top-img">
                     <div class="recruitment-img1">
                        <img src="../../assets/img/me-img1.png" width="100%">
                      </div>
                      <div class="jg"></div>
                      <div class="recruitment-img1">
                        <img src="../../assets/img/me-img2.png" width="100%">
                      </div>
                      <div class="jg"></div>
                      <div class="recruitment-img1">
                        <img src="../../assets/img/me-img3.png" width="100%">
                      </div>
                      <div class="jg"></div>
                      <div class="recruitment-img1">
                        <img src="../../assets/img/me-img4.png" width="100%">
                      </div>
                    </div>
                  </div>
                </Col>
                <Col span="2"></Col>
              </Row>

                <div class="employee-benefits">
                  <div class="emplo-img">
                    <p>员工福利</p>
                  </div>
                  <Row>
                    <Col span="2" />
                    <Col span="20">
                      <div class="employee-cont">
                        <div class="employee-cont-word1 employee-Block" >
                          <div class="emp">
                            <div class="emp-img">
                              <img src="../../assets/img/Year-end-bonuses.png" width="100%">
                            </div>
                            <div class="emp-word">
                              <span>年终奖金</span>
                            </div>
                          </div>
                        </div>
                        <div class="employee-Block"></div>
                        <div class="employee-cont-word1 employee-Block" >
                          <div class="emp">
                            <div class="emp-img">
                              <img src="../../assets/img/five-insurances.png" width="100%">
                            </div>
                            <div class="emp-word">
                              <span>五险一金</span>
                            </div>
                          </div>
                        </div>
                        <div class="employee-Block"></div>
                        <div class="employee-cont-word1 employee-Block" >
                          <div class="emp">
                            <div class="emp-img">
                              <img src="../../assets/img/group-tour.png" width="100%">
                            </div>
                            <div class="emp-word">
                              <span>团建旅游</span>
                            </div>
                          </div>
                        </div>
                        <div class="employee-Block"></div>
                        <div class="employee-cont-word1 employee-Block" >
                          <div class="emp">
                            <div class="emp-img">
                              <img src="../../assets/img/holiday-benefits.png" width="100%">
                            </div>
                            <div class="emp-word">
                              <span>节日礼物</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col span="2" />
                  </Row>
                </div>

                <Row>
                  <Col span="2"></Col>
                  <Col span="20">
                    <div class="post">
                      <h3>招聘岗位</h3>
                      <div class="post-content">
                        <span class="post-span1">运维工程师(3人)</span>
                        <img src="../../assets/img/me-address.png" />
                        <span class="post-span2">武汉</span>
                      </div>
                      <div class="post-content">
                        <span class="post-span1">前端开发工程师(2人)</span>
                        <img src="../../assets/img/me-address.png" />
                        <span class="post-span2">武汉</span>
                      </div>
                      <div class="post-content">
                        <span class="post-span1">后端开发工程师(1人)</span>
                        <img src="../../assets/img/me-address.png" />
                        <span class="post-span2">武汉</span>
                      </div>
                      <div class="post-content">
                        <span class="post-span1">测试工程师(3人)</span>
                        <img src="../../assets/img/me-address.png" />
                        <span class="post-span2">武汉</span>
                      </div>
                      <div class="post-content">
                        <span class="post-span1">售前工程师(5人)</span>
                        <img src="../../assets/img/me-address.png" />
                        <span class="post-span2">武汉</span>
                      </div>
                      <div class="post-content">
                        <span class="post-span1">AI算法研发工程师(2人)</span>
                        <img src="../../assets/img/me-address.png" />
                        <span class="post-span2">武汉</span>
                      </div>
                      <div class="post-content">
                        <span class="post-span1">AI算法训练工程师(4人)</span>
                        <img src="../../assets/img/me-address.png" />
                        <span class="post-span2">武汉</span>
                      </div>
                      <div class="post-content">
                        <span class="post-span1">大数据开发工程师(3人)</span>
                        <img src="../../assets/img/me-address.png" />
                        <span class="post-span2">武汉</span>
                      </div>
                      <div class="post-content">
                        <span class="post-span1">数据挖掘工程师(1人)</span>
                        <img src="../../assets/img/me-address.png" />
                        <span class="post-span2">武汉</span>
                      </div>
                      <div class="post-content">
                        <span class="post-span1">项目经理（工程类）(2人)</span>
                        <img src="../../assets/img/me-address.png" />
                        <span class="post-span2">武汉</span>
                      </div>
                      <div class="post-content">
                        <span class="post-span1">项目经理（软件开发类）(3人)</span>
                        <img src="../../assets/img/me-address.png" />
                        <span class="post-span2">武汉</span>
                      </div>
                    </div>
                  </Col>
                  <Col span="2"></Col>
                </Row>
              </div>
          </TabPane>

          <TabPane label="联系我们">
            <Row>
              <Col span="2"></Col>
              <Col span="20" >
                <div class="connect">
                  <div class="connect-map">
                    <div class="connect-word">
                      <p>地址: 武汉市武昌区武珞路628号</p>
					  <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;亚贸广场A座2711室</span>
                      <p>电话: 027-87854441</p>
                    </div>
                    <div class="connect-img">

                    </div>
                  </div>
                </div>
              </Col>
              <Col span="2"></Col>
            </Row>
          </TabPane>
        </Tabs>
    </div>

  </div>
</template>

<script>
  import Arrow from '@/pages/components/Arrow'
	import PictureInfo from'../../util/PictureInfo.vue'
  export default {
    name: 'AboutContent1',
    components:{Arrow},
    data () {
        return {
				showImg:false,
				imgSrc: '',
            value2: 0,
            deveData:[
              {
                goodsId:0,
                year:2021,
                title:"创新",
                content:"以软件产品为核心,整合资源孵化生态,提高天鸿业务生态竞争力和价值"
              },
              {
                goodsId:1,
                year:2018,
                title:"扩张",
                content:"各业务告诉发展,逐步融合业务,提升竞争力,形成由专到全的生态发展格局"
              },
              {
                goodsId:2,
                year:2014,
                title:"进取",
                content:"重点发展智能化及大型系统集成项目,延申业务维度,领航市场新业态;重点业务领域,明确未来产品核心,研发软件产品"
              },
              {
                goodsId:3,
                year:2008,
                title:"转变",
                content:"稳中求变,由产品销售商转变为系统集成服务商,为用户提供专业全面的服务"
              },
              {
                goodsId:4,
                year:2005,
                title:"拼搏",
                content:"以PC、服务器、网络设备等产品销售业务为主体,奠定天鸿在线基础"
              },
              {
                goodsId:5,
                year:2000,
                title:"成立",
                content:"公司成立于2000年,标志着天鸿在线成立正式启航"
              }
            ],
			threeHonor:[
			  {
			    goodsId:0,
				img1:require("../../assets/img/business-license1.png"),
				img2:require("../../assets/img/safety-production-license1.png"),
				img3:require("../../assets/img/ITSS31.png"),
				word1:"企业营业执照",
				word2:"安全生产许可证",
				word3:"信息技术服务运行维护标准符合性证书（ITSS）等级叁级",
			  },
			  {
			    goodsId:1,
				img1:require("../../assets/img/integrity-management1.png"),
				img2:require("../../assets/img/quality-service1.png"),
				img3:require("../../assets/img/corporation-credit1.png"),
				word1:"诚信经营示范单位证书",
				word2:"质量服务诚信企业证书",
				word3:"企业资信等级AAA证书",
			  },
			  {
			    goodsId:2,
			  	img1:require("../../assets/img/corporate-credit1.jpg"),
			  	img2:require("../../assets/img/be-trustworthy1.png"),
			  	img3:"",
			  	word1:"企业资信等级AAA证书",
			  	word2:"重合同守信用证书",
			  	word3:"",
			  }
			],
			fourHonor:[
			  {
			    goodsId:0,
				img1:require("../../assets/img/CMI5.jpg"),
				img2:require("../../assets/img/contracting-qualification1.png"),
				img3:require("../../assets/img/teleservice11.jpg"),
				img4:require("../../assets/img/teleservice22.jpg"),
				img5:require("../../assets/img/quality-control1.jpg"),
				word1:"CMMI5软件成熟度认证证书",
				word2:"电子与智能化工程专业承包资质",
				word3:"增值电信业务经营许可证",
				word4:"增值电信业务经营许可证2",
				word5:"质量管理体系认证证书"
			  },
			  {
			    goodsId:1,
				img1:require("../../assets/img/environmental-management1.jpg"),
				img2:require("../../assets/img/healthy-safety1.jpg"),
				img3:require("../../assets/img/IT11.jpg"),
				img4:require("../../assets/img/IT22.jpg"),
				img5:require("../../assets/img/SI1.jpg"),
				word1:"环境管理体系认证证书",
				word2:"职业健康安全管理体系认证证书",
				word3:"信息技术服务管理体系认证证书",
				word4:"信息安全管理体系认证证书2",
				word5:"系统集成服务综合管理系统"
			  },
			  {
				goodsId:2,
			  	img1:require("../../assets/img/123.jpg"),
			  	img2:require("../../assets/img/cloud-platform1.jpg"),
			  	img3:require("../../assets/img/Intelligent-monitoring-system1.jpg"),
			  	img4:require("../../assets/img/intelligent-control-system1.jpg"),
			  	img5:require("../../assets/img/Operation-management-platform1.jpg"),
			  	word1:"系统集成管理云平台",
			  	word2:"系统集成智能化监控系统",
			  	word3:"系统集成智能控制系统",
			  	word4:"运营管理平台",
			  	word5:"运营管理手机端软件平台"
			  },
			]
        }
    },
		components: {
		            'big-img':PictureInfo
		        },
		methods: {
		           clickImg(e) {
		               this.showImg = true;
		               // 获取当前图片地址
		               this.imgSrc = e.currentTarget.src;
		           },
		           viewImg(){
		               this.showImg = false;
		           },
		       }
	
  }

</script>

<style lang="less">

  @font-face{
      font-family: 'hzgt';
      src : url('../../assets/font/hzgt.ttf');
  }

  // .ivu-tabs-nav-container{
  //   line-height: 2.5;
  // }
  .about-me{
    .about-me-top{
      background-size: 100% 100%;
      background-image: url(../../assets/img/about-me-bj.jpg);
      background-repeat: no-repeat;
      .me-top-word{
        padding-top: 2.5rem;
        text-align: center;
        height: 9.8rem;
        h2{
          font-family: SourceHanSansCN-Medium;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;
        }
        p{
          margin-top: 0.1rem;

          	font-family: SourceHanSansCN-Light;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;
        }
      }
    }
    .about-me-center{
		background-image: linear-gradient(#f4f5fa, #fdfdfd);
      .ivu-tabs-nav-scroll{
        display: flex;
        justify-content: center;
      }
      .ivu-tabs-nav .ivu-tabs-tab-active{
        color: #ffffff;
        background: #2d8cf0;
      }
      .ivu-tabs-ink-bar{
        display: none;
      }
      .ivu-tabs-nav .ivu-tabs-tab{
        margin-right: 0;
        padding: 12px 76px;
        box-shadow: 0 0 5px #eaeff5 inset;
        font-size: 18px;
      }
      .ivu-tabs{
        position: relative;
        z-index: 1;
      }
      .ivu-tabs-bar{
       // position: absolute;
    top: 0;
    z-index: 2;
    background: #ffffff;
    margin: 0 auto;
    border: none;
      }
      .development{
        background-size: 100% 100%;
        background-image: url(../../assets/img/development-bj.jpg);
        background-repeat: no-repeat;
        padding-top: 0.5rem;
        padding-bottom: 1.5rem;
        .deve-content{
          display: flex;
          .deve-left{
            flex: 8;
            padding-left: 1.5rem;
            padding-top: 0.5rem;
            .deve-left-content{
              border-bottom: solid 1px #dcdee2;
              margin-bottom: 0.1rem;
            }
          }
          .deve-center{
            flex: 1;
            .deve-center-top{
              text-align: center;
              background: #2d8cf0;
              border-radius: 3px;
              height: 30px;
              line-height: 30px;
              span{
                    color: #ffffff;
                    font-weight: bolder;
                    font-size: 18px;
              }
            }
            .deve-center-line{
                  height: 30px;
                  background: #2d8cf0;
                  width: 1.8px;
                  margin: 0 auto;
            }
            .deve-center-outer-circle{
              width: 20px;
              height: 20px;
              border: solid 1px #2d8cf0;
              border-radius: 10px;
              margin: 0 auto;
              padding-top: 2px;
              .inner-circle{
                width: 14px;
                height: 14px;
                background: #2d8cf0;
                border-radius: 50%;
                margin: 0 auto;
              }
            }
          }
          .deve-right{
            flex: 8;
            padding-right: 1.5rem;
            padding-top: 0.5rem;
            .deve-right-content{
              border-bottom: solid 1px #dcdee2;
              margin-bottom: 0.1rem;
            }
          }
        }
      }
      .companyStructure{
        background-size: 100% 100%;
        background-image: url(../../assets/img/company-structure-bj.jpg);
        background-repeat: no-repeat;
        // padding-top: 1rem;
        .company-img{
          padding:0.5rem 1rem 1rem 1rem;
        }
      }
      .honor{
        padding-top: 0.5rem;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
		.Three-honor{
			display: flex;
			.Three-honor1{
				text-align: center;
				background-color: #ffffff;
				height: 3.2rem;
				flex: 2;
				margin-bottom: 1rem;
				padding: 0.05rem;
				p{
					margin-top: 0.3rem;
					// line-height: 1rem;
				}
				.Three-honor2{
					background-image: linear-gradient(#f4f5fa, #fdfdfd);
					height: 100%;
					padding: 0.2rem;
					.Three-honor3{
						width: 100%;
						height: 100%;
						background: #ffffff;
						padding: 0.1rem;
					}
				}
			}
			.Three-honor-interval{
				flex: 0.5;
			}
		}
		.Four-honor{
			display: flex;
			.Four-honor1{
				text-align: center;
				background-color: #ffffff;
				height: 3.7rem;
				flex: 2;
				margin-bottom: 1rem;
				padding: 0.05rem;
				p{
					margin-top: 0.3rem;
				}
				.Four-honor2{
					background-image: linear-gradient(#f4f5fa, #fdfdfd);
					height: 100%;
					padding: 0.2rem;
					.Four-honor3{
						width: 100%;
						height: 100%;
						background: #ffffff;
						padding: 0.1rem;
					}
				}
			}
			.Four-honor-interval{
				flex: 0.3;
			}
		}
        // .scoller{
        //   display: flex;
        //   .year{
        //     font-family: 'hzgt';
        //     padding: 0 0.5rem;
        //     font-size: 0.5rem;
        //     color: #9dadc1;
        //   }
        //   .year-content{
        //     p{
        //       margin-bottom: 0.2rem;
        //     }
        //   }
        // }
      }
      .recruitment{
        padding-top: 0.5rem;
        .recruitment-word{
          padding-left: 0.5rem;
          padding-right: 0.5rem;
          h3{
            text-align: center;
            margin-bottom: 0.3rem;
            font-size: 22px;
          }
          p{
            text-align: left;
            text-indent: 2em;
            line-height: 30px;
          }
        }
        .recruitment-img{
          margin-top: 0.3rem;
          .top-img{
            display: flex;
            padding-left: 0.5rem;
            padding-right: 0.5rem;
            .recruitment-img1{
              flex: 10;
            }
            .jg{
              flex: 1;
            }
          }
        }
      }
      .employee-benefits{
        background-size: 100% 100%;
        background-image: url(../../assets/img/company-bj.png);
        background-repeat: no-repeat;
        height: 2.7rem;
        position: relative;
        margin-top: 1.5rem;

        .emplo-img{
          background-size: 100% 100%;
          background-image: url(../../assets/img/me-arrow.png);
          background-repeat: no-repeat;
          width: 1.5rem;
          height: 1rem;
          text-align: center;
          position: relative;
          top: -0.4rem;
          margin: 0 auto;
          p{
            line-height: 0.9rem;
            color: #FFFFFF;
          }
        }
        .employee-cont{
          display: flex;
          padding-left: 1.9rem;
          padding-right: 1.9rem;
          .employee-cont-word1{
            height: 2rem;
            .emp{
              margin: 0 auto;
              width: 1.2rem;
              height: 1.2rem;
              background-size: 100% 100%;
              background-image: url(../../assets/img/polygon.png);
              background-repeat: no-repeat;
              .emp-img{
                padding: 0.2rem 0.4rem 0rem 0.4rem;
                img{
                  height: 0.4rem;
                }
              }
              .emp-word{
                text-align: center;
                span{
                   font-family: SourceHanSansCN-Regular;
                   font-size: 15px;
                   font-weight: normal;
                   font-stretch: normal;
                   // line-height: 0px;
                   letter-spacing: 0px;
                   color: #8d9caf;
                }
              }
            }
          }
          .employee-Block{
            flex: 1;
          }
        }
      }
      .post{
        margin-bottom: 0.5rem;
		padding: 0 0.5rem;
        h3{
          margin-top: 1.5rem;
          text-align: center;
          margin-bottom: 0.5rem;
          font-size: 22px;
        }
        .post-content{
        border: solid 1px #f1f2f7;
        padding: 0.1rem;
        margin-bottom: 0.3rem;
          .post-span2{
            float: right;
          }
          img{
            float: right;
            width: 1.2%;
            margin-left: 0.1rem;
          }
        }
      }
      .connect{
        padding-left: 0.5rem;
        padding-right: 1rem;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        .connect-map{
          background-size: 100% 100%;
          background-image: url(../../assets/img/connect-map.png);
          background-repeat: no-repeat;
          height: 5rem;
          position: relative;
          .connect-word{
            // width: 4rem;
            background: #fff;
            position: absolute;
            top: 1rem;
            left: 4rem;
   //          padding-left: 0.2rem;
			// padding-right: 0.2rem;
			padding: 0.2rem;
            padding-bottom: 0.2rem;
            border-radius: 2%;
          }
          .connect-img{
            background-size: 100% 100%;
            background-image: url(../../assets/img/connect-address.png);
            background-repeat: no-repeat;
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 2.6rem;
            left: 5.5rem;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/about-me-content/AboutMeContent1.vue